import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_cookies_h1 = _resolveComponent("cookies-h1")
  const _component_cookies_p = _resolveComponent("cookies-p")
  const _component_cookies_button = _resolveComponent("cookies-button")
  const _component_cookies_panel = _resolveComponent("cookies-panel")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_cookies_panel, null, {
      default: _withCtx(() => [
        _createVNode(_component_cookies_h1, null, {
          default: _withCtx(() => [
            _createTextVNode(" Shufflet ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_cookies_p, null, {
          default: _withCtx(() => [
            _createTextVNode(" Trouvez le/les anagramme(s) correspondant au mot du jour: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.wordOfTheDay), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anagrams, (anagram, i) => {
          return (_openBlock(), _createElementBlock("div", null, [
            (_ctx.found[anagram])
              ? (_openBlock(), _createBlock(_component_cookies_p, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Anagramme trouvé: " + _toDisplayString(anagram) + " ! ", 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true),
            (!_ctx.found[anagram])
              ? (_openBlock(), _createElementBlock("div", { key: 1 }, [
                  _createVNode(_component_cookies_p, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.wordHint(anagram)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createElementVNode("input", {
                    onKeyup: $event => (_ctx.tryWord($event.target.value, i))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["onKeyup"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("br")
          ]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        (Object.keys(_ctx.found).length === _ctx.anagrams.length)
          ? (_openBlock(), _createElementBlock("div", { key: 0 }, [
              _createVNode(_component_cookies_p, { style: {"text-align":"center"} }, {
                default: _withCtx(() => [
                  _createTextVNode(" 🎉 C'est gagné pour aujourd'hui ! 🥳 "),
                  _createElementVNode("br"),
                  _createVNode(_component_cookies_button, {
                    title: "Copier dans le presse-papier",
                    onClick: $event => (_ctx.share())
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Partager ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}